export default [
    {
        path: '/admin/teaching-calendars',
        name: 'teaching-calendar',
        meta: { requiresAuth: true },
        component: () => import("@/pages/human-resource/teaching-calendar")
    }
];
